import Graduationcap from './Graduationcap';

export default Graduationcap;
